import { parseJwt } from '../../../services/auth';
import { getUsernameFromToken } from '../../../services/riseAI';

/**
 * Extract org ID from JWT token or context
 */
export const extractOrgId = (jwtToken, currentOrgId) => {
  // Use org_id from UserContext first (set in App.js from token)
  if (currentOrgId) {
    return currentOrgId;
  }

  // Fallback to extracting from token if not available in context
  if (!jwtToken) {
    return null;
  }

  try {
    const decodedToken = parseJwt(jwtToken);
    // Check for org_id in namespaced field (Auth0 custom claims pattern)
    if (process.env.REACT_APP_AUTH0_NAMESPACE) {
      const auth0Namespace = process.env.REACT_APP_AUTH0_NAMESPACE;
      const orgIdNamespace = auth0Namespace + 'org_id';
      const orgId = decodedToken?.[orgIdNamespace];
      if (orgId) return orgId;
    }
    // Fallback to direct org_id field if namespaced field not found
    return decodedToken?.org_id || null;
  } catch (error) {
    console.warn('Failed to extract org_id from token:', error);
    return null;
  }
};

/**
 * Build chat payload
 */
export const buildChatPayload = (messageText, sessionId, jwtToken) => {
  const usernameForPayload = getUsernameFromToken(jwtToken) || 'user';

  return {
    appName: 'rise_ai_llm_agent',
    userId: usernameForPayload,
    sessionId: sessionId,
    newMessage: {
      role: 'user',
      parts: [
        {
          text: messageText
        }
      ]
    }
  };
};

export const REST_VEX_REMEDIATION_STATUS_TO_VEX_STATUS = {
  VEX_STATUS_UNSPECIFIED: 'UNSPECIFIED',
  VEX_STATUS_NOT_AFFECTED: 'NOT_AFFECTED',
  VEX_STATUS_AFFECTED: 'AFFECTED',
  VEX_STATUS_FIXED: 'FIXED',
  VEX_STATUS_UNDER_INVESTIGATION: 'UNDER_INVESTIGATION',
  VEX_STATUS_RESOLVED_WITH_PEDIGREE: 'RESOLVED_WITH_PEDIGREE',
  VEX_STATUS_FALSE_POSITIVE: 'FALSE_POSITIVE'
};

export function toVexStatusFromRest(value) {
  if (value == null) return REST_VEX_REMEDIATION_STATUS_TO_VEX_STATUS.VEX_STATUS_UNSPECIFIED;

  const key = typeof value === 'number' ? value : String(value);
  return REST_VEX_REMEDIATION_STATUS_TO_VEX_STATUS[key] ?? REST_VEX_REMEDIATION_STATUS_TO_VEX_STATUS.VEX_STATUS_UNSPECIFIED;
}
